import { render, staticRenderFns } from "./GoogleTranslate.vue?vue&type=template&id=4ac87bf4&"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js&"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js&"
import style0 from "./GoogleTranslate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports